import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
 
import { USER_SLICE_LABEL } from "./storeLabels";
 import { updateUserData, updateUserLogout, updateLogout, updateUser, updateAccessToken } from "./slices/user";
import type { RootState } from "./store";

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  matcher: isAnyOf(
    updateUserData,
    updateUserLogout,
    updateLogout,
    updateUser,
    updateAccessToken,
  ),
  effect: (_, listenerApi) => {
    localStorage.setItem(
      USER_SLICE_LABEL,
      JSON.stringify((listenerApi.getState() as RootState).auth),
    );
  },
});
